import { ComparisonOperators } from '@/constants/ComparisonOperators'
import { OnlyEnemies } from '@/constants/OnlyEnemyConstants'
import {
  MAP_BOSS_PROBABILITIES,
  MAP_NAME1_LIST,
  MAP_NAME2_LIST,
  MAP_NAME3_LIST,
  MAP_TYPE_PROBABILITIES
} from '@/constants/TMapBasicConstants'

const pulldownStyle: React.CSSProperties = {
  fontSize: '15px',
  height: '24px',
  margin: 'auto 10px auto 0'
}

const textStyle: React.CSSProperties = {
  height: '20px',
  margin: 'auto 10px auto 0'
}

const divStyle: React.CSSProperties = {
  margin: 'auto 10px auto 0'
}

const FromMapRank = ({ value1, value2 }: { value1: string; value2: string }) => {
  const rankList = ['02', '38', '3D', '4C', '51', '65', '79', '8D', 'A1', 'B5', 'C9', 'DD']

  return (
    <>
      <input type='hidden' name='key' value='mapRank[]' />
      <select style={pulldownStyle} name='value1' defaultValue={value1}>
        {rankList.map((s) => (
          <option value={s} key={s}>
            0x{s}
          </option>
        ))}
      </select>
      <select style={pulldownStyle} name='value2' defaultValue={value2}>
        {ComparisonOperators.map((s, i) => (
          <option value={i} key={i}>
            {s}
          </option>
        ))}
      </select>
    </>
  )
}

const FromMapSeed = ({ value1, value2 }: { value1: string; value2: string }) => {
  return (
    <div style={divStyle}>
      <input type='hidden' name='key' value='mapSeed[]' />
      0x{' '}
      <input
        type='text'
        name='value1'
        style={textStyle}
        pattern='[0-9a-fA-F]{4}'
        title='4桁の16進文字列を指定してください。3桁以下の場合は先頭に0を付けてください。'
        maxLength={4}
        required
        defaultValue={value1}
      />
      <select style={pulldownStyle} name='value2' defaultValue={value2}>
        {ComparisonOperators.filter((_, i) => i < 2).map((s, i) => (
          <option value={i} key={i}>
            {s}
          </option>
        ))}
      </select>
    </div>
  )
}

const FromMapName1 = ({ value1, value2 }: { value1: string; value2: string }) => {
  return (
    <>
      <input type='hidden' name='key' value='mapName1Index[]' />
      <select style={pulldownStyle} name='value1' defaultValue={value1}>
        {MAP_NAME1_LIST.map((s, i) => (
          <option value={i} key={i}>
            {s}
          </option>
        ))}
      </select>
      <select style={pulldownStyle} name='value2' defaultValue={value2}>
        {ComparisonOperators.filter((_, i) => i < 2).map((s, i) => (
          <option value={i} key={i}>
            {s}
          </option>
        ))}
      </select>
    </>
  )
}

const FromMapName2 = ({ value1, value2 }: { value1: string; value2: string }) => {
  return (
    <>
      <input type='hidden' name='key' value='mapName2Index[]' />
      <select style={pulldownStyle} name='value1' defaultValue={value1}>
        {MAP_NAME2_LIST.map((s, i) => (
          <option value={i} key={i}>
            {s}
          </option>
        ))}
      </select>
      <select style={pulldownStyle} name='value2' defaultValue={value2}>
        {ComparisonOperators.filter((_, i) => i < 2).map((s, i) => (
          <option value={i} key={i}>
            {s}
          </option>
        ))}
      </select>
    </>
  )
}

const FromMapName3 = ({ value1, value2 }: { value1: string; value2: string }) => {
  return (
    <>
      <input type='hidden' name='key' value='mapName3Index[]' />
      <select style={pulldownStyle} name='value1' defaultValue={value1}>
        {MAP_NAME3_LIST.map((s, i) => (
          <option value={i} key={i}>
            {s}
          </option>
        ))}
      </select>
      <select style={pulldownStyle} name='value2' defaultValue={value2}>
        {ComparisonOperators.filter((_, i) => i < 2).map((s, i) => (
          <option value={i} key={i}>
            {s}
          </option>
        ))}
      </select>
    </>
  )
}

const FromMapLevel = ({ value1, value2 }: { value1: string; value2: string }) => {
  return (
    <>
      <input type='hidden' name='key' value='mapLevel[]' />
      <input type='number' name='value1' style={textStyle} min={1} max={99} required defaultValue={value1} />
      <select style={pulldownStyle} name='value2' defaultValue={value2}>
        {ComparisonOperators.map((s, i) => (
          <option value={i} key={i}>
            {s}
          </option>
        ))}
      </select>
    </>
  )
}

const FromPlace = ({ value1 }: { value1: string }) => {
  const anchorStyle = { color: 'blue' }
  return (
    <div style={divStyle}>
      <input type='hidden' name='key' value='places[]' />
      0x{' '}
      <input
        type='text'
        name='value1'
        style={textStyle}
        pattern='[0-9a-fA-F]{2}'
        title='2桁の16進文字列を指定してください。1桁の場合は先頭に0を付けてください。'
        maxLength={2}
        required
        defaultValue={value1}
      />
      を含む（
      <a
        href='https://alittleoldgames.com/tools/dq9-grotto-location-identification-tool/'
        target='_blank'
        rel='noopener noreferrer'
        style={anchorStyle}
      >
        場所コードを調べる
      </a>
      ）
    </div>
  )
}

const FromMapType = ({ value1, value2 }: { value1: string; value2: string }) => {
  return (
    <>
      <input type='hidden' name='key' value='mapTypeIndex[]' />
      <select style={pulldownStyle} name='value1' defaultValue={value1}>
        {MAP_TYPE_PROBABILITIES.map((s, i) => (
          <option value={i} key={i}>
            {s.name}
          </option>
        ))}
      </select>
      <select style={pulldownStyle} name='value2' defaultValue={value2}>
        {ComparisonOperators.filter((_, i) => i < 2).map((s, i) => (
          <option value={i} key={i}>
            {s}
          </option>
        ))}
      </select>
    </>
  )
}

const FromFloorCount = ({ value1, value2 }: { value1: string; value2: string }) => {
  return (
    <>
      <input type='hidden' name='key' value='floorCount[]' />
      <input type='number' name='value1' style={textStyle} min={2} max={16} required defaultValue={value1} />
      <select style={pulldownStyle} name='value2' defaultValue={value2}>
        {ComparisonOperators.map((s, i) => (
          <option value={i} key={i}>
            {s}
          </option>
        ))}
      </select>
    </>
  )
}

const FromB1fEnemyRank = ({ value1, value2 }: { value1: string; value2: string }) => {
  return (
    <>
      <input type='hidden' name='key' value='b1fEnemyRank[]' />
      <input type='number' name='value1' style={textStyle} min={1} max={9} required defaultValue={value1} />
      <select style={pulldownStyle} name='value2' defaultValue={value2}>
        {ComparisonOperators.map((s, i) => (
          <option value={i} key={i}>
            {s}
          </option>
        ))}
      </select>
    </>
  )
}

const FromBoss = ({ value1, value2 }: { value1: string; value2: string }) => {
  return (
    <>
      <input type='hidden' name='key' value='bossIndex[]' />
      <select style={pulldownStyle} name='value1' defaultValue={value1}>
        {MAP_BOSS_PROBABILITIES.map((s, i) => (
          <option value={i} key={i}>
            {s.name}
          </option>
        ))}
      </select>
      <select style={pulldownStyle} name='value2' defaultValue={value2}>
        {ComparisonOperators.filter((_, i) => i < 2).map((s, i) => (
          <option value={i} key={i}>
            {s}
          </option>
        ))}
      </select>
    </>
  )
}

const FromTreasureBox = ({
  queryKey,
  value1,
  value2
}: {
  queryKey: string
  value1: string
  value2: string
}) => {
  const items = ['S箱', 'A箱', 'B箱', 'C箱', 'D箱', 'E箱', 'F箱', 'G箱', 'H箱', 'I箱', '宝総数']
  const keys = [
    'boxS[]',
    'boxA[]',
    'boxB[]',
    'boxC[]',
    'boxD[]',
    'boxE[]',
    'boxF[]',
    'boxG[]',
    'boxH[]',
    'boxI[]',
    'boxTotalCount[]'
  ]
  return (
    <>
      <select style={pulldownStyle} name='key' defaultValue={queryKey}>
        {items.map((s, i) => (
          <option value={keys[i]} key={i}>
            {s}
          </option>
        ))}
      </select>
      <input type='number' name='value1' style={textStyle} min={0} max={40} required defaultValue={value1} />
      <select style={pulldownStyle} name='value2' defaultValue={value2}>
        {ComparisonOperators.map((s, i) => (
          <option value={i} key={i}>
            {s}
          </option>
        ))}
      </select>
    </>
  )
}

const FromSpecialFloor = ({ queryKey, value1 }: { queryKey: string; value1: string }) => {
  const items = ['敵無', 'オンリー', '敵減']
  const keys = ['isNoEnemy[]', 'isOnly[]', 'isFewEnemy[]']
  return (
    <>
      <select style={pulldownStyle} name='key' defaultValue={queryKey}>
        {items.map((s, i) => (
          <option value={keys[i]} key={i}>
            {s}
          </option>
        ))}
      </select>
      <select style={pulldownStyle} name='value1' defaultValue={value1}>
        {['無し', '有り'].map((s, i) => (
          <option value={i} key={i}>
            {s}
          </option>
        ))}
      </select>
      <input type='hidden' name='value2' value='0' />
    </>
  )
}

const FromOnlyEnemy = ({ value1, value2 }: { value1: string; value2: string }) => {
  return (
    <>
      <input type='hidden' name='key' value='onlyEnemyId[]' />
      <select style={pulldownStyle} name='value1' defaultValue={value1}>
        {Object.entries(OnlyEnemies).map((s, i) => (
          <option value={s[0]} key={i}>
            {s[1]}
          </option>
        ))}
      </select>
      <select style={pulldownStyle} name='value2' defaultValue={value2}>
        {ComparisonOperators.filter((_, i) => i < 2).map((s, i) => (
          <option value={i} key={i}>
            {s}
          </option>
        ))}
      </select>
    </>
  )
}

export {
  FromMapRank,
  FromMapSeed,
  FromMapName1,
  FromMapName2,
  FromMapName3,
  FromMapLevel,
  FromPlace,
  FromMapType,
  FromFloorCount,
  FromB1fEnemyRank,
  FromBoss,
  FromTreasureBox,
  FromSpecialFloor,
  FromOnlyEnemy
}
